<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options="options"
      :page="page"
      :items-per-page="itemsPerPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :multi-sort="multiSort"
      v-on="listeners"
    >
      <template v-slot:item.first_name="{ item }">
        {{ item.first_name || '-' }}
      </template>
      <template v-slot:item.last_name="{ item }">
        {{ item.last_name || '-' }}
      </template>
      <template v-slot:item.type="{ item }">
        {{ item.type.name || '-' }}
      </template>
      <template v-slot:item.zip="{ item }">
        {{ item.zip || '-' }}
      </template>
      <template v-slot:item.city="{ item }">
        {{ item.city || '-' }}
      </template>
      <template v-slot:item.mobile="{ item }">
        {{ item.mobile || '-' }}
      </template>
      <template v-slot:item.last_update="{ item }">
        {{ item.last_update | dateFormat }}
      </template>
      <template v-slot:item.is_service_employee="{ item }">
        <v-checkbox v-model="item.is_service_employee" disabled></v-checkbox>
      </template>
      <template v-slot:item.username="{ item }">
        {{ item.username || '-' }}
      </template>
      <template v-slot:item.is_active="{ item }">
        <v-chip :color="getStatus(item).color" text-color="white">
          {{ getStatus(item).name }}
        </v-chip>
      </template>

      <template v-slot:item.action="{ item }">
        <action-slot-component
          :item="item"
          route-name="employees.show"
          open-in-new-window
          :route-params="{ id: item.id }"
          @show="$emit('show', item)"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { dateFormat } from '@/modules/_global/filters';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { mapCacheActions } from 'vuex-cache';
import listItems from '@/modules/_global/mixins/list-items';
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'EmployeesList',
  components: { ActionSlotComponent },

  filters: {
    dateFormat
  },

  mixins: [i18nRefreshData, listItems],

  data: () => ({
    statuses: []
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('EMPLOYEES.FIRST_NAME'),
          sortable: true,
          value: 'first_name'
        },
        {
          text: this.$t('EMPLOYEES.LAST_NAME'),
          sortable: true,
          value: 'last_name'
        },
        {
          text: this.$t('EMPLOYEES.ABACUS_NUMBER'),
          sortable: true,
          value: 'abacus_id'
        },
        {
          text: this.$t('EMPLOYEES.TYPE'),
          sortable: true,
          value: 'type'
        },
        {
          text: this.$t('EMPLOYEES.ZIP'),
          sortable: true,
          value: 'zip'
        },
        {
          text: this.$t('EMPLOYEES.CITY'),
          sortable: true,
          value: 'city'
        },
        {
          text: this.$t('EMPLOYEES.MOBILE_PHONE'),
          sortable: true,
          value: 'mobile'
        },
        {
          text: this.$t('EMPLOYEES.LAST_UPDATE'),
          sortable: true,
          value: 'last_update'
        },
        {
          text: this.$t('EMPLOYEES.SERVICE_EMPLOYEE'),
          sortable: true,
          value: 'is_service_employee'
        },
        {
          text: this.$t('EMPLOYEES.USERNAME'),
          sortable: true,
          value: 'username'
        },
        {
          text: this.$t('EMPLOYEES.STATUS'),
          sortable: true,
          value: 'is_active'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.getDataEmployeeStatuses().then(() => {
        this.$emit('refresh', {
          params: Object.assign({}, this.options, this.params)
        });
      });
    },
    ...mapCacheActions('employee', ['getEmployeeStatuses']),

    getDataEmployeeStatuses() {
      return this.getEmployeeStatuses().then(({ data }) => {
        this.statuses = data.data;
      });
    },
    getStatus(item) {
      if (item.is_active === null) {
        return { name: '', color: '' };
      }

      return this.statuses.find(el => el.id === Number(item.is_active));
    }
  }
};
</script>
